/* Cart sequencing and storefront offer checks. Server-side checkout validation is still required. */
(function (host) {
  'use strict';
  function create(options) {
    var request = options.fetch, cart = null, writes = 0, reads = 0, generation = 0;
    var transactions = Object.create(null), failed = Object.create(null);
    var checking = null, blocked = true, refreshTimer = null;
    function pending() { return writes > 0 || Object.keys(transactions).length > 0; }
    function state() { if (options.onState) options.onState({pending:pending() || !!checking, blocked:blocked}); }
    function error(message) { blocked = true; if (options.onError) options.onError(message); state(); }
    function json(url, data) {
      var init = {credentials:'same-origin', headers:{Accept:'application/json'}, cache:'no-store'};
      if (data !== undefined) { init.method='POST'; init.headers['Content-Type']='application/json'; init.body=JSON.stringify(data); }
      return Promise.resolve().then(function(){return request(url, init);}).then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message || 'Your cart could not be updated. Please try again.');
          return body;
        });
      });
    }
    function read() {
      var sequence = ++reads, version = generation;
      return json('/cart.js').then(function (next) {
        if (!next || !Array.isArray(next.items) || !Number.isSafeInteger(next.total_price) || next.total_price < 0) throw new Error('Your cart could not be verified. Please refresh and try again.');
        if (sequence === reads && version === generation) { cart=next; if (options.onCart && !options.beforeInspect) options.onCart(cart); }
        return next;
      });
    }
    function inspect(next) {
      if (!options.policy || typeof options.policy.inspect !== 'function') throw new Error('We could not verify your offers. Please refresh before checking out.');
      Object.keys(failed).forEach(function(id) {
        if (!next.items.some(function(item) { return (item.properties || {})._bundle === id; })) delete failed[id];
      });
      if (Object.keys(failed).length) throw new Error('A bundle could not be completed. Remove that bundle and add it again before checking out.');
      return options.policy.inspect(next, options.config || {});
    }
    function settle() {
      if (checking) return checking;
      if (pending()) return Promise.resolve(null);
      blocked=true;
      var version=generation, corrected=false;
      function pass(attempt) {
        return read().then(function(next) {
          if (pending() || version !== generation) return null;
          return Promise.resolve(options.beforeInspect ? options.beforeInspect(next) : next).then(function(verified) {
          if (!verified || pending() || version !== generation) return null;
          if (!Array.isArray(verified.items) || !Number.isSafeInteger(verified.total_price) || verified.total_price < 0) throw new Error('Your cart could not be verified. Please refresh and try again.');
          next=verified;
          cart=next;
          if(options.onCart && options.beforeInspect) options.onCart(cart);
          var report=inspect(next);
          if(!report || !Array.isArray(report.updates) || !Array.isArray(report.errors)) throw new Error('Your offers could not be verified. Please refresh your cart.');
          if (report.updates.length) {
            if (attempt >= 5) throw new Error('Your offers changed. Please refresh your cart before checking out.');
            var updates={}; report.updates.forEach(function(update) { updates[update.key]=update.quantity; });
            return json('/cart/update.js', {updates:updates}).then(function() { corrected=true;return pass(attempt+1); });
          }
          if (report.errors.length) throw new Error(report.errors[0]);
          blocked=false;
          if(options.onError) options.onError('');
          if(corrected && options.onCorrected) options.onCorrected(next);
          return next;
          });
        });
      }
      checking=Promise.resolve().then(function() { return pass(0); }).catch(function(e) {
        error(e.message || 'We could not verify your offers. Please try again.'); throw e;
      }).finally(function() {
        checking=null; state();
        if(version!==generation && !pending()) schedule();
      });
      state();
      return checking;
    }
    function schedule() {
      clearTimeout(refreshTimer);
      refreshTimer=setTimeout(function() { settle().catch(function(){}); },80);
    }
    function refresh() {
      if(pending()) return read();
      return settle();
    }
    function mutate(url,data) {
      if(pending() || checking) return Promise.reject(new Error('Please wait for the current cart update.'));
      writes++; generation++; blocked=true; state();
      var failure;
      return json(url,data).catch(function(e) { failure=e; }).then(function() {
        writes--; state();
        return settle().then(function(next) {
          if(failure) { error(failure.message); throw failure; }
          return next;
        });
      });
    }
    function begin(id) { if(!id) return; transactions[id]=true; generation++; blocked=true; state(); }
    function end(id,rollbackFailed) {
      delete transactions[id];
      if(rollbackFailed) failed[id]=true;
      generation++; blocked=true; state(); schedule();
    }
    function externalStart() { writes++; generation++; blocked=true; state(); }
    function externalEnd() { writes=Math.max(0,writes-1); generation++; state(); schedule(); }
    function verify() {
      if(pending()) return Promise.reject(new Error('Your cart is updating. Please try again in a moment.'));
      return (checking || Promise.resolve()).then(function() { return settle(); }).then(function(next) {
        if(!next || blocked || pending() || !next.items.length) throw new Error('Your cart is not ready. Please review it before checking out.');
        return next;
      });
    }
    return {refresh:refresh, mutate:mutate, verify:verify, begin:begin, end:end, externalStart:externalStart, externalEnd:externalEnd,
      pending:pending, blocked:function(){return blocked;}, checking:function(){return !!checking;}};
  }
  host.HSCartIntegrity={create:create};
  if(typeof module==='object' && module.exports) module.exports=host.HSCartIntegrity;
})(typeof window==='object' ? window : globalThis);
